export default "__VITE_ASSET___Q7bHPvW__"